import m from "mithril";
import blockwrapper from "../../../old/blockwrapper/blockwrapper.js";

export default () => {
	return {
		view: ({
			attrs: {tid, category, prid, blockcode, appcode, defaultpagesize, showasfields, stripdata, fixed_editable, row},
		}) => {
			return m(blockwrapper, {
				tid,
				category,
				prid,
				blockcode,
				appcode,
				expanded: true,
				tact: "dummy",
				groups: "prasora",
				showasfields,
				stripdata,
				groups: undefined,
				defaultpagesize,
				fixed_editable,
				row,
			});
		},
	};
};
